module.exports = __webpack_public_path__ + "media/images/fr/success-d63b715a042f2e1395111a4341d44bd8.png";